<template>
  <div>
    <BACK title="編輯物件買賣" name='Home'/>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="買賣種類" prop="SellType">
        <div class="clear">
          <el-checkbox v-for="({id, name},idx) in sellType" v-model="interviewOption[idx]" :key="idx" @change="chengeJobType(idx)">{{name}}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item label="選擇地區" prop="areaId">
        <div class="clear">
          <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaId" placeholder="請選擇">
            <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId" :key="idx" />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="金額" prop="amount">
        <div class="flex">
          <el-input v-model="form.amount" type="number" clearable placeholder="面議" oninput="if(value.length>5)value=value.slice(0,8)" ></el-input>
        </div>
      </el-form-item>
        <el-form-item label="聯絡姓名" prop="contactName">
            <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                      placeholder="請輸入聯絡人名稱"></el-input>
        </el-form-item>
        <el-form-item label="聯絡資訊" prop="contactMemo">
            <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                      placeholder="請輸入聯絡資訊"></el-input>
        </el-form-item>
      <el-form-item label="刊登標題" prop="title">
        <el-input v-model="form.title" type="text" oninput="value=value.replace(value.slice(20),'')" clearable placeholder="輸入標題"></el-input>
      </el-form-item>
      <el-form-item label="內容敘述" prop="content">
        <el-input v-model="form.content" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="上傳圖片(點選圖片可操作刪除)" prop="photo">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action="#"
          :file-list="fileList"
          :on-change="beforeAvatarUpload"
          :auto-upload="false"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :limit="imgLimit"
          :on-exceed="handleExceed"
          accept="image/jpeg,image/jpg,image/png"
          list-type="picture">
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <p class="avatar-uploader-text">選擇檔案</p>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="note">*文章均遵守<span class="tag"  @click="openTerms">《服務條款》</span></div>
    <div class="btn">
      <el-button type="success" :disabled="loading" @click="handleSubmit()"><i class="el-icon-loading" v-if="loading"></i>送出</el-button>
    </div>
  </div>
</template>
<script>

import BACK from '@/components/back.vue'
import FN from '@/components/fn'
import { mapActions, mapGetters } from 'vuex'
import { getStorage } from '@/util'
import axios from 'axios'

export default {
  name: 'add',
  components: {
    BACK
  },
  mixins: [FN],
  data() {
    return {
      fileList: [],
      imagesList: [],
      imgLimit: 10,
      interviewOption: {
        0: false,
        1: false
      },
      form:{
        title: '',
        areaId: 1,
        amount: '',
        saleType: '',
        saleTypeId: '',
        content : '',
        deleteImages: [],
        images: [],
        contactName: '',
        contactMemo: ''
      }
    }
  },
  mounted() {
    //取得資料並寫入
    this.getDetail()
  },
  computed: {
    ...mapGetters([
      'sellType',
      'searchArea',
      'sellDetail'
    ]),
    rules() {
        const message = '輸入不完整'
        // 自訂驗證-SellType
        const isSellType = (rule, value, callback) => {
          if(!this.interviewOption[0] && !this.interviewOption[1]){
            callback(new Error(message))
          }else{
            callback()
          }
        }
        return {
            SellType: [
                { required: true, trigger: 'change', validator: isSellType }
            ],
            areaId: [{ required: true, trigger: 'change', message }],
            title: [{ required: true, trigger: 'change', message:"請輸入刊登標題" }],
            content: [{ required: true, trigger: 'change', message:"請輸入內容敘述" }],
            contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
            contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
        }
    }
  },
  methods: {
    ...mapActions([
      'FETCH'
    ]),
    getFileList() {
      const data = this.sellDetail?.images || []
      data.forEach(({name, id, url},idx) => {
        this.fileList.push({
          'id': id,
          'name': name,
          'url': url
        })
      });
    },
    chengeJobType(idx) {
      if(this.interviewOption[idx]){
        this.interviewOption[Math.abs(idx-1)] = false
        this.form.saleTypeId = +this.sellType[idx].id
      }
    },
    beforeFormSubmit() {
      this.form.saleType = this.form.saleTypeId
      this.imagesList.forEach(({imageId}) => {
        this.form.images.push(imageId)
      });
    },
    //送出表單
    handleSubmit() {
      const id = this.$route.params.id
      const form = this.$refs.form
      this.beforeValidate()
      form.validate((valid) => {
          if (valid) {
              this.loading = true
              this.beforeFormSubmit()
              this.FETCH({
                key: 'SELL_EDIT',
                id: id,
                ...this.form
              }).then((res) => {
                //需要accToken的驗證
                if(+(res || {}).code === -3){
                  this.checkNewToken(this.handleSubmit)
                }else{
                  this.handleResponse(res)
                }
              })
          } else {
              this.loading = false
              this.handleUnValid()
          }
      })

    },
    //回應
    handleResponse(res) {
      //const id = this.$route.params.id
      if (!+res.code) {
        this.$confirm('修改成功',{
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'success'
        })
        .then(() => {
          // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
          // window.open(href, '_self')
          this.$router.replace({name: 'Sell', params:{ tag: 'my'}})
          this.$parent.handleSearch()
        })
      }else{
        this.$confirm(res.message,{
          showCancelButton: false,
          type: 'error'
        })
      }
      this.loading = false
    },
    getDetail() {
      const id = this.$route.params.id
      this.FETCH({
        key: 'SELL_DETAIL',
        id: id
      }).then((res) => {
        //需要accToken的驗證
        if(+(res || {}).code === -3){
          this.checkNewToken(this.getDetail)
        }
        if(!+res){
          this.form = {
              ...this.form,
              ...this.sellDetail
          }
          this.interviewOption[+this.sellDetail.saleTypeId - 1] = true
          this.form.images = []
          this.getFileList()
        }
      })
    },
    openTerms() {
      this.$parent.dialogVisible = true
    },
    handleBack() {
      const id = this.$route.params.id
      this.$router.replace({name: 'SellDetails', params:{ id: id}})
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`確定移除 ${ file.name }？`);
    },
    handleRemove(file, fileList) {
      const id = file.id || null
      const fileUid = file.uid || null
      if(id){
        this.form.deleteImages.push(id)
      }else{
        this.imagesList = this.imagesList.filter(({uid}) => uid !== fileUid )
      }
    },
    beforeAvatarUpload(file,fileList) {
      this.loading = true;
      // const isPNG = file.raw.type === 'image/png';
      // const isJPG = file.raw.type === 'image/jpeg';
      // const isSVG = file.raw.type === 'image/svg+xml';
      // const isLt2M = file.raw.size / 1024 / 1024 < 3;
      // if (!(isJPG || isPNG || isSVG)) {
      //   this.$message.error('上传头像图片只能是 JPG/PNG/SVG 格式!');
      //   this.handleRemove(file,fileList)
      //   return true
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 3MB!');
      //   this.handleRemove(file,fileList)
      //   return true
      // }
      // if((isJPG || isPNG || isSVG) && isLt2M){
        this.handleUpload(file.raw)
      // }
    },
    handleExceed() {
      return this.$message.error(`最多上傳${this.imgLimit}張圖片!`);
    },
    handleUpload(file) {
      const isLogin = getStorage('assessToken')
      axios.defaults.headers.common['Authorization'] = isLogin
      const form = new FormData()
      form.append('image', file)
      // 上傳到後端伺服器
      axios.post('/api/file/image/upload', form).then((res) => {
        const code = res?.data?.code
        //需要accToken的驗證
        if(+code === -3){
          const token = getStorage('refreshToken')
          this.FETCH({
            key: 'LOGIN_STATE',
            refreshToken: token
          }).then((res) => {
            if(!+(res || {}).code){
              this.handleToken((res || {}).data)
              this.handleUpload(file)
            }else{
              this.$confirm('登入逾時',{
                showCancelButton: false,
                type: 'error'
              })
              .then(() => {
                location.href = '/app/'
              })
            }
          })
        }
        //上傳成功
        if(!+code){
          const data = res.data.data
          this.imagesList.push({
            uid: file.uid,
            imageId: data.imageId,
            name: file.name,
            fileName: data.fileName
          });
        }
        this.loading = false;
      });

    }
  }
}
</script>
